import { render } from "./ErrorTooltip.vue?vue&type=template&id=0bb1701f&scoped=true"
import script from "./ErrorTooltip.vue?vue&type=script&lang=js"
export * from "./ErrorTooltip.vue?vue&type=script&lang=js"

import "@/styles/ErrorTooltip.css?vue&type=style&index=0&id=0bb1701f&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb1701f"]])

export default __exports__